import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import curved9 from "assets/images/o4.png";
import toast from "react-hot-toast";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { baseURL } from 'utils/api';
// import OTP from "./otp";
import Reset from "./reset";
import CircularProgress from '@mui/material/CircularProgress';

function SignIn() {

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [email, setEmail] = useState("");
  const [show, setShow] = useState(false);
  const [oldOtp, setOldOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");


  const HandleSignIn = () => {
    setValidationMessage("");
    
    if (!email) {
      setValidationMessage("Email is required");
      return;
    }
    if (!email.includes("@") || !email.includes(".")) {
      setValidationMessage("Please enter a valid email address");
      return;
    }

    setLoading(true);
    fetch(`${baseURL}forgot-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, role: "BUSINESS" }),
    }).then((res) => res.json())
      .then((resp) => {
        if (resp.success) {
          navigate("/login")
          return toast.success(resp?.message);
        }
        if (!resp.success) {
          setValidationMessage(resp.error || resp?.message);
          return;
        }
      }).catch((err) => {
        setValidationMessage(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <CoverLayout
      title={"Forgot Password"}
      description={"Enter your email  to forgot your password"}
      image={curved9}
      forgot={true}
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Email
            </SoftTypography>
          </SoftBox>

          <SoftInput
            required={true}
            placeholder="Enter email"
            onWheel={(e) => e.target.blur()}
            name="email"
            maxLength={10}
            type="text"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setValidationMessage("");
            }}
            error={!!validationMessage}
          />
          {validationMessage && (
            <SoftTypography 
              variant="caption" 
              sx={{ 
                color: 'error.main',
                fontSize: '0.75rem',
                marginTop: '4px',
                display: 'block'
              }}
            >
              {validationMessage}
            </SoftTypography>
          )}
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton
            onClick={() => HandleSignIn()}
            variant="gradient" 
            color="info" 
            fullWidth
            disabled={loading}
            sx={{ position: 'relative' }}
          >
            {loading ? (
              <>
                <CircularProgress
                  size={24}
                  sx={{
                    color: '#fff',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                    '& .MuiCircularProgress-circle': {
                      strokeWidth: 3
                    }
                  }}
                />
                <span style={{ visibility: 'hidden' }}>Submit</span>
              </>
            ) : (
              "Submit"
            )}
          </SoftButton>
        </SoftBox></SoftBox>
      {show == 2 && <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <OTP email={email} oldOtp={oldOtp} setOldOtp={setOldOtp} setShow={setShow} />
          </SoftBox>
        </SoftBox>
      </SoftBox>}

      {
        show == 3 && <SoftBox component="form" role="form">
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <Reset email={email} setShow={setShow} />
            </SoftBox>
          </SoftBox>
        </SoftBox>

      }


      <SoftBox mt={3} textAlign="center" >
        <SoftTypography variant="button" color="text" fontWeight="regular">
          Already have an account?{" "}
          <SoftTypography
            component={Link}
            to="/login"
            variant="button"
            color="info"
            fontWeight="medium"
            textGradient
          >
            Sign in
          </SoftTypography>
        </SoftTypography>
      </SoftBox>



    </CoverLayout>
  );
}

export default SignIn;
